// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"205":"574fe3bf","374":"c04eefbc","484":"1bef058b","551":"f08f88f6","629":"a6fc9f5f","672":"8c930295","842":"8df647c5","869":"d1c6690c","974":"2be7b50c"}[chunkId] + ".chunk.js";
};